/* MAXPROMO STYLE — galerie stable sur toutes les fiches produit */
(function () {
  'use strict';
  if (window.__MXP_GLOBAL_GALLERY_STABLE_V2__) return;
  window.__MXP_GLOBAL_GALLERY_STABLE_V2__ = true;

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
  }

  function optionIndex(input) {
    if (!input) return -1;
    var match = String(input.name || '').match(/option-(\d+)/);
    return match ? parseInt(match[1], 10) - 1 : -1;
  }

  function groupName(group) {
    if (!group) return '';
    var label = group.querySelector('.option__label');
    return normalize(label ? label.textContent : (group.getAttribute('data-option-name') || ''));
  }

  function selectedColorInfo(form) {
    if (!form) return { key: '', index: -1, value: '', composite: false };
    var groups = Array.prototype.slice.call(form.querySelectorAll('.option'));
    var i;

    /* Produits classiques : option Couleur / Color dediee. */
    for (i = 0; i < groups.length; i++) {
      var directName = groupName(groups[i]);
      if (directName.indexOf('COULEUR') === -1 && directName.indexOf('COLOR') === -1) continue;
      var direct = groups[i].querySelector('input[type="radio"][name^="option-"]:checked');
      if (!direct) continue;
      return {
        key: 'DIRECT|' + normalize(direct.value),
        index: optionIndex(direct),
        value: String(direct.value || ''),
        composite: false
      };
    }

    /* MacBook : Couleur|CPU|RAM|Stockage est encode dans Configuration. */
    for (i = 0; i < groups.length; i++) {
      var compositeName = groupName(groups[i]);
      if (compositeName.indexOf('CONFIGURATION') === -1) continue;
      var composite = groups[i].querySelector('input[type="radio"][name^="option-"]:checked');
      if (!composite || String(composite.value || '').indexOf('|') === -1) continue;
      var color = String(composite.value || '').split('|')[0].trim();
      return {
        key: 'COMPOSITE|' + normalize(color),
        index: optionIndex(composite),
        value: color,
        composite: true
      };
    }

    /* Secours pour le configurateur MacBook visuel. */
    var custom = form.querySelector('.mps-mac-color-group .mps-mac-color-choice[aria-pressed="true"][data-value]');
    if (custom) {
      var customValue = String(custom.getAttribute('data-value') || '').trim();
      return {
        key: 'CUSTOM|' + normalize(customValue),
        index: -1,
        value: customValue,
        composite: true
      };
    }

    return { key: '', index: -1, value: '', composite: false };
  }

  function variantMatchesColor(variant, info) {
    if (!variant || !variant.options || !info || info.index < 0 || !info.value) return false;
    var value = String(variant.options[info.index] || '');
    if (info.composite) value = value.split('|')[0].trim();
    return normalize(value) === normalize(info.value);
  }

  function galleryState(product) {
    if (!product) return null;
    var main = product.querySelector('[data-gallery-main]');
    var current = product.querySelector('[data-gallery-thumb][aria-current="true"]');
    if (!main) return null;
    return {
      src: main.getAttribute('src') || '',
      srcset: main.getAttribute('srcset'),
      currentMediaId: current ? String(current.getAttribute('data-media-id') || '') : ''
    };
  }

  function restoreGalleryState(product, state) {
    if (!product || !state) return;
    var main = product.querySelector('[data-gallery-main]');
    if (main && state.src) {
      main.setAttribute('src', state.src);
      if (state.srcset === null) main.removeAttribute('srcset');
      else main.setAttribute('srcset', state.srcset);
    }
    if (state.currentMediaId) {
      Array.prototype.forEach.call(product.querySelectorAll('[data-gallery-thumb]'), function (thumb) {
        thumb.setAttribute('aria-current', String(thumb.getAttribute('data-media-id') || '') === state.currentMediaId ? 'true' : 'false');
      });
    }
  }

  var suppressProgrammaticThumb = false;

  function armGlobalGalleryLock() {
    if (window.__mxpGlobalGalleryLock) return;
    window.__mxpGlobalGalleryLock = true;

    /* Capture avant theme.js : seules les vraies modifications de couleur ont le droit de changer l'image. */
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('input[type="radio"]')) return;
      var form = input.closest('form[data-product-form]');
      if (!form) return;
      var product = form.closest('[data-product]');

      var info = selectedColorInfo(form);
      var oldKey = form.dataset.mxpGalleryColorKey || '';
      var colorChanged = Boolean(info.key && info.key !== oldKey);

      if (info.key) form.dataset.mxpGalleryColorKey = info.key;
      form.dataset.mxpGalleryAllowNext = colorChanged ? '1' : '0';

      if (colorChanged) return;

      /* Memoriser l'image actuelle : certains scripts tablette changent directement le src sans cliquer une miniature. */
      var stableState = galleryState(product);
      var manualVersion = parseInt(form.dataset.mxpGalleryManualVersion || '0', 10);

      suppressProgrammaticThumb = true;
      window.setTimeout(function () {
        if (parseInt(form.dataset.mxpGalleryManualVersion || '0', 10) === manualVersion) restoreGalleryState(product, stableState);
      }, 35);
      window.setTimeout(function () {
        if (parseInt(form.dataset.mxpGalleryManualVersion || '0', 10) === manualVersion) restoreGalleryState(product, stableState);
        suppressProgrammaticThumb = false;
      }, 120);
    }, true);

    /* Les clics manuels du client sur une miniature restent toujours prioritaires. */
    document.addEventListener('click', function (event) {
      var target = event.target;
      var thumb = target && target.closest ? target.closest('[data-gallery-thumb]') : null;
      if (!thumb) return;

      if (event.isTrusted) {
        var form = thumb.closest('[data-product]') && thumb.closest('[data-product]').querySelector('form[data-product-form]');
        if (form) form.dataset.mxpGalleryManualVersion = String(parseInt(form.dataset.mxpGalleryManualVersion || '0', 10) + 1);
        return;
      }

      if (!suppressProgrammaticThumb) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);
  }

  function syncVariantImage(form) {
    if (!form) return;
    var product = form.closest('[data-product]');
    if (!product) return;

    var dataEl = product.querySelector('[data-variants-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent || '[]');
    } catch (error) {
      return;
    }

    var chosen = Array.prototype.map.call(
      form.querySelectorAll('input[type="radio"]:checked'),
      function (input) { return input.value; }
    );

    var match = variants.find(function (variant) {
      return variant.options && variant.options.every(function (value, index) {
        return value === chosen[index];
      });
    });

    /* Si la variante exacte n'a pas d'image, reutiliser l'image d'une variante de la meme couleur. */
    if (!match || !match.featured_image || !match.featured_image.id) {
      var info = selectedColorInfo(form);
      var colorMatch = variants.find(function (variant) {
        return variantMatchesColor(variant, info) && variant.featured_image && variant.featured_image.id;
      });
      if (colorMatch) match = colorMatch;
    }

    if (!match || !match.featured_image || !match.featured_image.id) return;

    var thumb = product.querySelector(
      '[data-gallery-thumb][data-media-id="' + match.featured_image.id + '"]'
    );
    if (thumb) thumb.click();
  }

  function seedColor(form) {
    if (!form || form.dataset.mxpGalleryColorSeeded === '1') return;
    form.dataset.mxpGalleryColorSeeded = '1';
    var info = selectedColorInfo(form);
    if (info.key) form.dataset.mxpGalleryColorKey = info.key;
  }

  function init(root) {
    armGlobalGalleryLock();

    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll('form[data-product-form]');
    if (!forms.length && scope !== document) {
      forms = document.querySelectorAll('form[data-product-form]');
    }

    Array.prototype.forEach.call(forms, function (form) {
      seedColor(form);

      window.requestAnimationFrame(function () {
        syncVariantImage(form);
      });

      if (form.dataset.mxGalleryFixReady === 'true') return;
      form.dataset.mxGalleryFixReady = 'true';

      form.addEventListener('change', function (event) {
        if (!event.target.matches('input[type="radio"]')) return;
        if (form.dataset.mxpGalleryAllowNext !== '1') return;

        window.requestAnimationFrame(function () {
          syncVariantImage(form);
          form.dataset.mxpGalleryAllowNext = '0';
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
